import { render, staticRenderFns } from "./CostBearersToDo.vue?vue&type=template&id=22b54010&scoped=true&"
import script from "./CostBearersToDo.vue?vue&type=script&lang=ts&"
export * from "./CostBearersToDo.vue?vue&type=script&lang=ts&"
import style0 from "./CostBearersToDo.vue?vue&type=style&index=0&id=22b54010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b54010",
  null
  
)

export default component.exports